import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCustomerGifts, getReceivedGifts } from './thunks';
import { GiftsState } from './types';

export const name = 'gifts';

const initialState: GiftsState = {
  custormerGifts: {
    data: [],
    status: 'idle',
  },
  receivedGifts: {
    data: [],
    status: 'idle',
  },
};

export const getCustomerGiftsAsync = createAsyncThunk(
  name + '/getCustomerGifts',
  getCustomerGifts
);

export const getReceivedGiftsAsync = createAsyncThunk(
  name + '/getReceivedGifts',
  getReceivedGifts
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerGiftsAsync.pending, (state) => {
        state.custormerGifts.status = 'loading';
      })
      .addCase(getCustomerGiftsAsync.fulfilled, (state, action) => {
        state.custormerGifts = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getCustomerGiftsAsync.rejected, (state) => {
        state.custormerGifts.status = 'failed';
      })
      .addCase(getReceivedGiftsAsync.pending, (state) => {
        state.receivedGifts.status = 'loading';
      })
      .addCase(getReceivedGiftsAsync.fulfilled, (state, action) => {
        state.receivedGifts = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getReceivedGiftsAsync.rejected, (state) => {
        state.receivedGifts.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
